export default __webpack_public_path__ + "beta-maps-examples-user-location-view-1200-0e2f13fa91e8f1da75a1efb1ff3c664a.png";